module.exports = {"623025100":"尼玛镇","623025101":"曼日玛镇","623025102":"阿万仓镇","623025103":"齐哈玛镇","623025104":"采日玛镇","623025105":"欧拉镇","623025201":"欧拉秀玛乡","623025203":"木西合乡","623025400":"河曲马场","623025401":"大水军牧场","623025402":"高原生物研究所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623025.json
// module id = 2976
// module chunks = 0